export default __webpack_public_path__ + "static/media/LOCK_IDLE.92a51c4b.svg";